import { adminClusteredPinsImages } from '../AdminClusteredPins';
import { trailCollectionImages } from '../TrailCollection';
import DynamicStyleOverlays from './DynamicStyleOverlays';

export default DynamicStyleOverlays;

export const dynamicStyleImages = {
  ...trailCollectionImages,
  ...adminClusteredPinsImages
};
